import { CreatePosologySliceDto, PosologySliceType } from '@services/dtos'
import { groupBy, sortBy } from 'lodash'

export function validatePosologySlices(
  slices: CreatePosologySliceDto[],
): Set<number> {
  const invalidIndices = new Set<number>()

  const groups = groupBy(
    slices.map((slice, originalIndex) => ({ ...slice, originalIndex })),
    'patientType',
  )

  for (const group of Object.values(groups)) {
    const eanmSlices = group.filter(({ type }) => type === PosologySliceType.EANM)
    if (eanmSlices.length > 1) {
      eanmSlices.forEach(({ originalIndex }) => invalidIndices.add(originalIndex))
    }
    const sorted = sortBy(
      group.filter(({ type }) => type !== PosologySliceType.EANM),
      ({ weightMin }) => weightMin ?? 0,
    )

    for (let i = 0; i < sorted.length - 1; i++) {
      const current = sorted[i]
      const next = sorted[i + 1]

      if ((next.weightMin ?? 0) < (current.weightMax ?? Infinity)) {
        invalidIndices.add(current.originalIndex)
        invalidIndices.add(next.originalIndex)
      }
    }
  }

  return invalidIndices
}
